import {createSlice} from '@reduxjs/toolkit';

const filtersSlice = createSlice({
  name: 'filters',
  initialState: {},
  reducers: {
    setFilter: (state, action) => {
      const {tableId, columnId, value} = action.payload;
      if (!state[tableId]) {
        state[tableId] = {};
      }
      state[tableId][columnId] = value;
    },
    setGlobalFilter: (state, action) => {
      const {tableId, value} = action.payload;
      if (!state[tableId]) {
        state[tableId] = {};
      }
      state[tableId].globalFilter = value;
    },
    clearFilter: (state, action) => {
      const {tableId, columnId} = action.payload;
      if (state[tableId]) {
        delete state[tableId][columnId];
      }
    },
    clearAllFilters: (state, action) => {
      const {tableId} = action.payload;
      if (state[tableId]) {
        state[tableId] = {};
      }
    },
    clearColumnFilters: (state, action) => {
      const {tableId} = action.payload;
      if (state[tableId]) {
        // Сохраняем только глобальный фильтр
        const globalFilterValue = state[tableId].globalFilter;
        state[tableId] = {};
        if (globalFilterValue !== undefined) {
          state[tableId].globalFilter = globalFilterValue;
        }
      }
    }
  }
});

export const {
  setFilter,
  setGlobalFilter,
  clearFilter,
  clearAllFilters,
  clearColumnFilters
} = filtersSlice.actions;
export default filtersSlice.reducer;